import Landing from "../components/Landing/landing";
import Login from "../components/Login/login";
import { useNavigate } from "react-router-dom";
import Addproduct from "../components/product/addproduct";
import Disclaimers from "../components/product/disclaimers";
import howToAccessMembership from "../components/product/HowToAccessMembership";
import membershipBenefits from "../components/product/MembershipBenefits.jsx";
import planInformation from "../components/product/PlanInformation.jsx";
import summaryPlanDescription from "../components/product/SummaryPlanDescription.jsx";
import explanationOfBenefitsHistory from "../components/product/ExplanationOfBenefitsHistory.jsx";
import Editproduct from "../components/product/Editproduct.jsx";
import ScheduleCare from "../components/product/ScheduleCare";
import DigitizedIdCard from "../components/product/DigitizedIdCard";
import Faq from "../components/product/Faq";
import Editfaq from "../components/product/Editfaq";
import InsuranceCertification from "../components/product/InsuranceCertification";
import addclaims from "../components/product/addclaims.jsx";
import Claim from "../components/product/Claim";
import User from "../components/User/User";
import Notification from "../components/Notification/Notification";
import CreateNotification from "../components/Notification/CreateNotification";
import Groups from "../components/Groups/Groups";
import ManageMember from "../components/Groups/ManageMember";
import EditGroupProduct from "../components/Groups/EditGroupProduct";
import Usertemp from "../components/User/Usertemp";
import RedirectionUrl from "../components/Claim/RedirectionUrl.jsx";
import QuizComponent from "../components/Claim/QuizComponent.jsx";
import UpdateNotification from "../components/Notification/UpdateNotification.jsx";
import ClaimForm from "../components/Claim/ClaimForm.jsx";
import UpdateClaimForm from "../components/Claim/updateClaimForm.jsx";
import EditQuizForm from "../components/Claim/EditQuizForm.jsx";
import Report from "../components/Reports/Report.jsx";
import DPCExtra from "../components/DPCExtra/DPCExtra.jsx";
import AddDpcExtra from "../components/DPCExtra/addDpcExtra.jsx";
import AddDpcDiscount from "../components/DPCExtra/AddDpcDiscount.jsx";
import EditDpcDiscount from "../components/DPCExtra/EditDpcDiscount.jsx";
import DPCExtraGroup from "../components/DPCExtraGroup/DPCExtraGroup.jsx";
import AddDpcExtraGroup from "../components/DPCExtraGroup/addDpcExtraGroup.jsx";
import AddDpcDiscountGroup from "../components/DPCExtraGroup/AddDpcDiscountGroup.jsx";
import EditDpcDiscountGroup from "../components/DPCExtraGroup/EditDpcDiscountGroup.jsx";
import EmailTemplatesList from "../components/EmailTemplates/EmailTemplates.jsx";
import ManageEmailTemplates from "../components/EmailTemplates/ManageEmailTemplates.jsx";
import QceTemplates from "../components/QCETemplates/QceTemplates.jsx";
import ManageQceTemplate from "../components/QCETemplates/ManageQceTemplate.jsx";
import Product from "../components/Dashboard/product.jsx";
import Dashboard from "../components/Dashboard/dashboard.jsx";
import ReleaseDocuments from "../components/ReleaseDocuments/ReleaseDocuments.jsx";
import ManageReleaseDocuments from "../components/ReleaseDocuments/ManageReleaseDocuments.jsx";

const NoMatch = () => {
  const navigate = useNavigate();
  navigate("/dashboard");
};

export const routes = [
  {
    element: Landing,
    path: "/",
    isPrivate: false,
    isLayout: false,
  },
  {
    element: Product,
    path: "/product",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: Dashboard, 
    path: "/dashboard",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: Login,
    path: "/login",
    isPrivate: false,
    isLayout: false,
  },
  {
    element: Addproduct,
    path: "/addproduct",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: Disclaimers,
    path: "/disclaimers",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: howToAccessMembership,
    path: "/access-membership",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: membershipBenefits,
    path: "/membership-benefits",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: planInformation,
    path: "/plan-information",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: summaryPlanDescription,
    path: "/summary-plan-description",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: explanationOfBenefitsHistory,
    path: "/benefits-history",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: ScheduleCare,
    path: "/schedule-care",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: Editproduct,
    path: "/edit-product",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: DigitizedIdCard,
    path: "/digitized-id-card",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: InsuranceCertification,
    path: "/insurance-certification",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: addclaims,
    path: "/Add-claim",
    isPrivate: false,
    isLayout: true,
  },
  {
    element: Faq,
    path: "/faq",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: Editfaq,
    path: "/edit-faq",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: Claim,
    path: "/claim",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: DPCExtra,
    path: "/dpc-extra",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: DPCExtraGroup,
    path: "/dpc-extra-group",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: EditDpcDiscount,
    path: "/edit-dpc-extra",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: EditDpcDiscountGroup,
    path: "/edit-dpc-extra-group",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: AddDpcDiscount,
    path: "/add-dpc-discount",
    isPrivate: true,
    isLayout: true,
  },

  {
    element: AddDpcDiscountGroup,
    path: "/add-dpc-discount-group",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: AddDpcExtra,
    path: "/add-dpc",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: AddDpcExtraGroup,
    path: "/add-dpc-group",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: ClaimForm,
    path: "/claim-form",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: UpdateClaimForm,
    path: "/edit-claim-form",
    isPrivate: true,
    isLayout: true,
  },

  {
    element: User,
    path: "/user",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: Notification,
    path: "/notification",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: CreateNotification,
    path: "/create-notification",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: UpdateNotification,
    path: "/edit-notification",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: Groups,
    path: "/groups",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: ManageMember,
    path: "/manage-member",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: EditGroupProduct,
    path: "/edit-group-product",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: Usertemp,
    path: "/usertemp",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: RedirectionUrl,
    path: "/redirection-url",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: QuizComponent,
    path: "/quiz",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: EditQuizForm,
    path: "/edit-quiz-form",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: Report,
    path: "/reports",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: EmailTemplatesList,
    path: "/email-templates",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: ReleaseDocuments,
    path: "/release-documents",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: ManageReleaseDocuments,
    path: "/manage-release-document",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: ManageEmailTemplates,
    path: "/manage-email-template",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: QceTemplates,
    path: "/qce-templates",
    isPrivate: true,
    isLayout: true,
  },
  {
    element: ManageQceTemplate,
    path: "/manage-qce-templates",
    isPrivate: true,
    isLayout: true,
  },
  { path: "*", element: NoMatch },
];
